import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/app/[lang]/[esite]/legal/terms-and-conditions/terms-conditions.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/blocks-components.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/ect/ect-content/ect-content.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/ect/error.module.scss");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/espot/espot-content.tsx");
;
import(/* webpackMode: "eager" */ "/usr/server/app/apps/pcc-nextjs-bff/components/pcc-components.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/usr/server/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/usr/server/app/node_modules/react-error-boundary/dist/react-error-boundary.esm.js");
